<lib-page-layout>
  <lib-title-navbar pageHeader [customBackUrl]="customBackUrl" title="Płatność za gierkę"></lib-title-navbar>

  <div>
    <div class="or-head-xl or-mt-20-px or-mx-20-px or-text-align-center">Gierka została zakończona.</div>

    <div class="or-mb-20-px or-mt-12-px or-mx-20-px or-text-lg or-text-align-center or-color-secondary-2">
      {{ messageText() }}
    </div>

    @if (game(); as game) {
      <lib-game-card-v2
        [game]="game"
        [showHostDetails]="!isHostedGame()"
        [showPhoneNumber]="!isHostedGame()"
        [showBottomDetails]="false"></lib-game-card-v2>

      @if (!isHostedGame()) {
        <div class="or-d-flex or-justify-content-center or-my-20-px">
          <div class="custom-divider"></div>
        </div>

        <div class="or-d-flex or-justify-content-between or-mx-20-px or-text-lg">
          <div>Płatność za gierkę</div>
          <div>{{ game.priceAmount }} zł</div>
        </div>
      }

      <div class="or-d-flex or-justify-content-center or-my-20-px">
        <div class="custom-divider"></div>
      </div>

      <div>
        <lib-rating-app [gameId]="game.gameId" [isHostedGame]="isHostedGame()"></lib-rating-app>
      </div>
    }
  </div>
  <lib-bottom-navbar pageFooter></lib-bottom-navbar>
</lib-page-layout>
